import type { Video } from "@/models/video";
import type {
  Athlete,
  Duration,
  Equipment,
  Exercise,
  Pose,
  Sport,
  TargetArea,
} from "@/models/videoDetail";
import { API_BASE, type APIResponse, callApi } from "@/services/api";

export async function getVideoDetails(): Promise<
  APIResponse<{
    targetAreas: TargetArea[];
    durations: Duration[];
    equipment: Equipment[];
    exercises: Exercise[];
    poses: Pose[];
    athletes: Athlete[];
  }>
> {
  try {
    const resp = await callApi<{
      targetAreas: TargetArea[];
      durations: Duration[];
      equipment: Equipment[];
      exercises: Exercise[];
      poses: Pose[];
      athletes: Athlete[];
    }>(`${API_BASE}/video_details`);
    return resp;
  } catch (e: unknown) {
    return e as APIResponse<{
      targetAreas: TargetArea[];
      durations: Duration[];
      equipment: Equipment[];
      exercises: Exercise[];
      poses: Pose[];
      athletes: Athlete[];
    }>;
  }
}

export async function getTargetAreas(): Promise<APIResponse<TargetArea[]>> {
  try {
    const resp = await callApi<TargetArea[]>(`${API_BASE}/target_areas`);
    return resp;
  } catch (e: unknown) {
    return e as APIResponse<TargetArea[]>;
  }
}

export async function getAthletes(): Promise<APIResponse<Athlete[]>> {
  try {
    const resp = await callApi<Athlete[]>(`${API_BASE}/athletes`);
    return resp;
  } catch (e: unknown) {
    return e as APIResponse<Athlete[]>;
  }
}

export async function getSports(): Promise<APIResponse<Sport[]>> {
  try {
    const resp = await callApi<Sport[]>(`${API_BASE}/sports`);
    return resp;
  } catch (e: unknown) {
    return e as APIResponse<Sport[]>;
  }
}

export async function getPoseById(
  id: string | number,
): Promise<APIResponse<Pose>> {
  try {
    const resp = await callApi<Pose>(`${API_BASE}/poses/${id}`);
    return resp;
  } catch (e: unknown) {
    return e as APIResponse<Pose>;
  }
}

export async function getPoses(): Promise<APIResponse<Pose[]>> {
  try {
    const resp = await callApi<Pose[]>(`${API_BASE}/poses`);
    return resp;
  } catch (e: unknown) {
    return e as APIResponse<Pose[]>;
  }
}

export async function getPoseFilter(
  pose: string,
): Promise<APIResponse<Video[]>> {
  try {
    const resp = await callApi<Video[]>(
      `${API_BASE}/videos/search?pose_filters[]=${pose}`,
    );
    return resp;
  } catch (e: unknown) {
    return e as APIResponse<Video[]>;
  }
}
